import api, { apiWrapper } from '../api/axios';

export const checkVehicleNumber = async (vehicleNumber, excludeId = null) => {
  const params = { vehicle_number: vehicleNumber };
  if (excludeId) params.exclude_id = excludeId;
  return apiWrapper(() => api.get('/vehicle/check-number/', { params }));
};

export const getDimensions = async () => {
  return apiWrapper(() => api.get(`/vehicle/dimension/`));
};

export const getVehicleTypes = async () => {
  return apiWrapper(() => api.get(`/vehicle/vehicletype/`));
};

export const getVehicles = async ({
  status = 'all', dimension = 0,
  vehicle_type=0, vehicle_mode='', search=null, branch=0,
  page = 1, pageSize = 20, paginate = true}
) => {
  let params = {
    status,
    vehicle_type,
    vehicle_mode,
    dimension,
    branch,
    page,
    page_size: pageSize,
    paginate: paginate
  };
  if (search != null) {
    params = { ...params, search };
  }
  return apiWrapper(() => api.get(`/vehicle/`, { params }));
};

export const createVehicle = async (data) => {
  const formData = construct_form_data(data);
  return apiWrapper(() => api.post("/vehicle/", formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }));
};

export const updateVehicle = async (id, data) => {
  const formData = construct_form_data(data);
  return apiWrapper(() => api.put(`/vehicle/${id}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }));
};

export const updateVehiclePartial = async (id, data) => {
  const formData = construct_form_data(data);
  return apiWrapper(() => api.patch(`/vehicle/${id}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }));
};

export const toggleVehicleStatus = async (id, isActive) => {
  return apiWrapper(() => api.patch(`/vehicle/${id}/${isActive ? 'activate' : 'deactivate'}/`));
};

export const downloadVehicleDoc = async (id, doc_type) => {
  return apiWrapper(() => api.get(`/vehicle/${id}/download/${doc_type}/`));
};

const extract_id = (value) => {
  // If value is an object (e.g. a nested serializer response), extract its id.
  // Otherwise return the value as-is (already a primitive id).
  if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
    return value.id;
  }
  return value;
};

const construct_form_data = (data) => {

  let form = new FormData();

  // Add text fields
  form = add_field(form, 'vehicle_number', data?.vehicle_number);
  form = add_field(form, 'rc_number', data?.rc_number);
  form = add_field(form, 'vehicle_mode', data?.vehicle_mode);
  form = add_field(form, 'vehicle_type_id', extract_id(data?.vehicle_type_id) || extract_id(data?.vehicle_type));
  form = add_field(form, 'chassis_number', data?.chassis_number);
  form = add_field(form, 'dimension_id', extract_id(data?.dimension_id) || extract_id(data?.dimension));
  form = add_field(form, 'branch_id', extract_id(data?.branch_id) || extract_id(data?.branch));
  form = add_field(form, 'insurance_number', data?.insurance_number);
  form = add_field(form, 'insurance_expiry', data?.insurance_expiry);
  form = add_field(form, 'fc_date', data?.fc_date);
  form = add_field(form, 'is_active', data?.is_active ? 1 : 0);

  // Add file fields (make sure these are actual File objects from input type="file")
  form = add_field(form, 'rc_doc', data?.rc_doc);
  form = add_field(form, 'insurance_doc', data?.insurance_doc);
  form = add_field(form, 'fc_doc', data?.fc_doc);
  form = add_field(form, 'national_permit_doc', data?.national_permit_doc);
  form = add_field(form, 'state_permit_doc', data?.state_permit_doc);
  form = add_field(form, 'pollution_cert_doc', data?.pollution_cert_doc);
  form = add_field(form, 'tax_receipt_doc', data?.tax_receipt_doc);

  form = add_field(form, 'national_permit_date', data?.national_permit_date);
  form = add_field(form, 'state_permit_date', data?.state_permit_date);
  form = add_field(form, 'pollution_cert_date', data?.pollution_cert_date);
  form = add_field(form, 'tax_receipt_date', data?.tax_receipt_date);

  return form;
};

const add_field = (form, key, value) => {
  if (value) {
    form.append(key, value);
  }
  return form;
};
